// import React, { useEffect, useMemo, useState } from "react";
// import { getSnapperInsightDashboard } from "../services/snapperInsightService";
// import "./SnapperInsight.css";

// const fmt = (n) => new Intl.NumberFormat("en-IN").format(n || 0);

// function Avatar({ person }) {
//   const [broken, setBroken] = useState(false);
//   const name = person?.name || "Unknown";
//   if (person?.avatarUrl && !broken) {
//     return <img className="si-avatar" src={person.avatarUrl} alt={name} onError={() => setBroken(true)} />;
//   }
//   const initials = name.split(" ").map(x => x[0]).join("").slice(0, 2).toUpperCase();
//   return <div className="si-avatar si-avatar-fallback">{initials}</div>;
// }

// function Icon({ children }) {
//   return <span className="si-icon" aria-hidden="true">{children}</span>;
// }

// export default function SnapperInsight({
//   userId: propUserId,
//   onSnapperClick,
//   onOpenMap,
//   onExport
// }) {
//   const effectiveUserId = useMemo(() => {
//     if (propUserId) return propUserId;
//     const storedUser = localStorage.getItem("user") || sessionStorage.getItem("user");
//     if (storedUser) {
//       try {
//         const parsed = JSON.parse(storedUser);
//         if (parsed?.id) return parsed.id;
//       } catch (e) {
//         // Ignored if stored as plain string ID
//       }
//     }
//     return localStorage.getItem("userId") || sessionStorage.getItem("userId") || "";
//   }, [propUserId]);

//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const [country, setCountry] = useState("All Countries");
//   const [state, setState] = useState("All States");
//   const [city, setCity] = useState("All Cities");
//   const [selectedSnapper, setSelectedSnapper] = useState(null);
//   const [mapOpen, setMapOpen] = useState(false);

//   useEffect(() => {
//     const fetchDashboard = async () => {
//       if (!effectiveUserId) {
//         setLoading(false);
//         setError("Missing admin user authorization ID.");
//         return;
//       }

//       try {
//         setLoading(true);
//         setError(null);
//         const filters = { country, city };
//         const result = await getSnapperInsightDashboard(effectiveUserId, filters);
//         setData(result);
//       } catch (err) {
//         console.error("Snapper Insight API error:", err);
//         setError(err.message || "Failed to load dashboard data.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchDashboard();
//   }, [effectiveUserId, country, city]);

//   const filteredCities = useMemo(() => {
//     if (!data?.cities) return [];
//     return data.cities.filter(row =>
//       (state === "All States" || row.state === state) &&
//       (city === "All Cities" || row.city === city)
//     );
//   }, [data?.cities, state, city]);

//   const openMap = () => {
//     setMapOpen(true);
//     onOpenMap?.();
//   };

//   const closeMap = () => setMapOpen(false);

//   const selectSnapper = (person) => {
//     setSelectedSnapper(person);
//     onSnapperClick?.(person);
//   };

//   if (loading) {
//     return (
//       <div className="snapper-insight si-state-container">
//         <div className="si-spinner" />
//         <p>Fetching Snapper Intelligence...</p>
//       </div>
//     );
//   }

//   if (error || !data) {
//     return (
//       <div className="snapper-insight si-state-container">
//         <div className="si-error-box">
//           <h2>Unable to Load Dashboard</h2>
//           <p>{error || "No data available."}</p>
//           <button className="si-btn si-btn-primary" onClick={() => window.location.reload()}>
//             Retry
//           </button>
//         </div>
//       </div>
//     );
//   }

//   const { kpis, loginWindows, jobsWindows, profileHealth, filters, snappers, states } = data;

//   const activePct = kpis.registered ? ((kpis.active / kpis.registered) * 100).toFixed(1) : "0.0";
//   const worked30Pct = kpis.registered ? ((kpis.worked30 / kpis.registered) * 100).toFixed(1) : "0.0";

//   return (
//     <div className="snapper-insight">
//       <div className="si-page-head">
//         <div>
//           <div className="si-eyebrow">OPERATIONS / PEOPLE INTELLIGENCE</div>
//           <h1>Snapper Intelligence</h1>
//           <p>Understand your field capacity, activity and geographic coverage before planning the next campaign.</p>
//         </div>
//         <div className="si-head-actions">
//           <button className="si-btn si-btn-ghost" onClick={() => onExport?.()}>↓ Export</button>
//           <button className="si-btn si-btn-primary" onClick={openMap}>⌖ Open Coverage Map</button>
//         </div>
//       </div>

//       <section className="si-filterbar">
//         <div className="si-filter-title">
//           <span>FILTER VIEW</span>
//           <small>All figures update for the selected geography</small>
//         </div>
//         <label>Country
//           <select value={country} onChange={e => setCountry(e.target.value)}>
//             {(filters?.countries || ["All Countries"]).map(x => <option key={x} value={x}>{x}</option>)}
//           </select>
//         </label>
//         <label>State
//           <select value={state} onChange={e => { setState(e.target.value); setCity("All Cities"); }}>
//             {(filters?.states || ["All States"]).map(x => <option key={x} value={x}>{x}</option>)}
//           </select>
//         </label>
//         <label>City
//           <select value={city} onChange={e => setCity(e.target.value)}>
//             {(filters?.cities || ["All Cities"]).map(x => <option key={x} value={x}>{x}</option>)}
//           </select>
//         </label>
//         <button className="si-reset" onClick={() => { setCountry("All Countries"); setState("All States"); setCity("All Cities"); }}>Reset</button>
//       </section>

//       <section className="si-kpi-grid">
//         <article className="si-kpi">
//           <div className="si-kpi-icon blue"><Icon>◉</Icon></div>
//           <div className="si-kpi-label">REGISTERED SNAPPERS</div>
//           <div className="si-kpi-value">{fmt(kpis.registered)}</div>
//           <div className="si-kpi-note">All registered snapper accounts</div>
//         </article>
//         <article className="si-kpi">
//           <div className="si-kpi-icon green"><Icon>✓</Icon></div>
//           <div className="si-kpi-label">ACTIVE ACCOUNTS</div>
//           <div className="si-kpi-value">{fmt(kpis.active)}</div>
//           <div className="si-kpi-note"><strong>{activePct}%</strong> of registered base</div>
//         </article>
//         <article className="si-kpi">
//           <div className="si-kpi-icon purple"><Icon>↗</Icon></div>
//           <div className="si-kpi-label">WORKED IN LAST 30 DAYS</div>
//           <div className="si-kpi-value">{fmt(kpis.worked30)}</div>
//           <div className="si-kpi-note"><strong>{worked30Pct}%</strong> of registered base</div>
//         </article>
//         <article className="si-kpi">
//           <div className="si-kpi-icon amber"><Icon>◷</Icon></div>
//           <div className="si-kpi-label">DORMANT 180+ DAYS</div>
//           <div className="si-kpi-value">{fmt(kpis.dormant180)}</div>
//           <div className="si-kpi-note">Potential reactivation pool</div>
//         </article>
//       </section>

//       <div className="si-two-col">
//         <section className="si-panel">
//           <div className="si-panel-head">
//             <div><h2>Login Activity</h2><p>Recency of last login across registered snappers</p></div>
//           </div>
//           <div className="si-bars">
//             {loginWindows.map((item) => (
//               <div className="si-bar-row" key={item.label}>
//                 <span className="si-bar-label">{item.label}</span>
//                 <div className="si-bar-track">
//                   <div className="si-bar-fill" style={{ width: `${item.pct || 0}%` }} />
//                 </div>
//                 <strong>{fmt(item.value)}</strong>
//               </div>
//             ))}
//           </div>
//           <div className="si-insight green-note">
//             <strong>Planning signal:</strong> recently logged-in snappers are a stronger near-term capacity indicator than registration count.
//           </div>
//         </section>

//         <section className="si-panel">
//           <div className="si-panel-head">
//             <div><h2>Completed Jobs by Window</h2><p>Jobs with a completion date linked to a snapper</p></div>
//           </div>
//           <div className="si-bars si-job-bars">
//             {jobsWindows.map(item => (
//               <div className="si-bar-row" key={item.label}>
//                 <span className="si-bar-label">{item.label}</span>
//                 <div className="si-bar-track">
//                   <div className="si-bar-fill purple-fill" style={{ width: `${item.pct || 0}%` }} />
//                 </div>
//                 <strong>{fmt(item.value)}</strong>
//               </div>
//             ))}
//           </div>
//           <div className="si-job-highlight">
//             <span>{fmt(kpis.worked30)}</span>
//             <div>
//               <strong>Snappers worked in last 30 days</strong>
//               <small>Use this as the primary operational capacity signal.</small>
//             </div>
//           </div>
//         </section>
//       </div>

//       <section className="si-panel si-city-panel">
//         <div className="si-panel-head">
//           <div><h2>Snapper Coverage by City</h2><p>Registered base, active accounts and recently working capacity</p></div>
//           <button className="si-btn si-btn-ghost si-btn-sm" onClick={openMap}>⌖ Map View</button>
//         </div>
//         <div className="si-table-wrap">
//           <table className="si-table">
//             <thead><tr><th>City</th><th>Registered</th><th>Active</th><th>Worked 30d</th><th>Capacity</th><th>Share</th><th>Signal</th></tr></thead>
//             <tbody>
//               {filteredCities.map(row => (
//                 <tr key={row.city}>
//                   <td><strong>{row.city}</strong><small>{row.state}</small></td>
//                   <td>{fmt(row.registered)}</td>
//                   <td>{fmt(row.active)}</td>
//                   <td><strong>{fmt(row.worked30)}</strong></td>
//                   <td><div className="si-capacity"><div><span style={{ width: `${row.capacity || 0}%` }} /></div><em>{row.capacity || 0}%</em></div></td>
//                   <td>{row.share || 0}%</td>
//                   <td><span className={`si-signal ${(row.signal || "unknown").toLowerCase()}`}>{row.signal || "Unknown"}</span></td>
//                 </tr>
//               ))}
//               {!filteredCities.length && <tr><td colSpan="7" className="si-empty">No city records match the selected geography.</td></tr>}
//             </tbody>
//           </table>
//         </div>
//       </section>

//       <div className="si-two-col">
//         <section className="si-panel">
//           <div className="si-panel-head">
//             <div><h2>Recently Active Snappers</h2><p>Useful for urgent and location-sensitive jobs</p></div>
//           </div>
//           <div className="si-snapper-grid">
//             {snappers.slice(0, 6).map(person => (
//               <button className="si-snapper-card" key={person.id} onClick={() => selectSnapper(person)}>
//                 <Avatar person={person} />
//                 <div className="si-snapper-info">
//                   <strong>{person.name}</strong>
//                   <span>{person.city} · {person.type}</span>
//                   <small>Completed <b>{person.jobs30}</b> jobs · Last login <b>{person.lastLogin}</b></small>
//                 </div>
//                 <span className={`si-ready ${(person.readiness || "unknown").toLowerCase()}`}>{person.readiness}</span>
//               </button>
//             ))}
//             {!snappers.length && <div className="si-empty">No active snappers found.</div>}
//           </div>
//         </section>

//         <section className="si-panel">
//           <div className="si-panel-head">
//             <div><h2>State-wise Coverage</h2><p>Top states by snappers who worked in the last 30 days</p></div>
//           </div>
//           <div className="si-state-list">
//             {states.map((item, i) => (
//               <div className="si-state-row" key={item.name}>
//                 <div>
//                   <strong>{item.name}</strong>
//                   <small>{fmt(item.registered)} registered</small>
//                   <div className="si-state-track"><span style={{ width: `${Math.max(8, 100 - i * 11)}%` }} /></div>
//                 </div>
//                 <b>{fmt(item.worked30)}</b>
//               </div>
//             ))}
//             {!states.length && <div className="si-empty">No state breakdown available.</div>}
//           </div>
//         </section>
//       </div>

//       <section className="si-panel si-readiness">
//         <div className="si-panel-head">
//           <div><h2>Snapper Readiness</h2><p>Onboarding and account signals useful before assigning new work</p></div>
//         </div>
//         <div className="si-readiness-grid">
//           <div>
//             <span>Active account</span>
//             <strong>{fmt(kpis.active)} <small>{activePct}%</small></strong>
//             <div className="si-progress"><i style={{ width: `${activePct}%` }} /></div>
//           </div>
//           <div>
//             <span>Photo-job onboarding complete</span>
//             <strong>{fmt(profileHealth.photoOnboarding)} <small>{profileHealth.photoOnboardingPct}%</small></strong>
//             <div className="si-progress"><i style={{ width: `${profileHealth.photoOnboardingPct}%` }} /></div>
//           </div>
//           <div>
//             <span>Video-job onboarding complete</span>
//             <strong>{fmt(profileHealth.videoOnboarding)} <small>{profileHealth.videoOnboardingPct}%</small></strong>
//             <div className="si-progress"><i style={{ width: `${profileHealth.videoOnboardingPct}%` }} /></div>
//           </div>
//           <div>
//             <span>Blocked accounts</span>
//             <strong>{fmt(profileHealth.blocked)} <small>{profileHealth.blockedPct}%</small></strong>
//             <div className="si-progress warning"><i style={{ width: `${profileHealth.blockedPct}%` }} /></div>
//           </div>
//         </div>
//       </section>

//       {selectedSnapper && (
//         <div className="si-overlay" onMouseDown={e => e.target === e.currentTarget && setSelectedSnapper(null)}>
//           <div className="si-drawer">
//             <div className="si-drawer-head">
//               <div><span>SNAPPER PROFILE</span><h2>{selectedSnapper.name}</h2></div>
//               <button onClick={() => setSelectedSnapper(null)}>×</button>
//             </div>
//             <div className="si-profile-top">
//               <Avatar person={selectedSnapper} />
//               <div>
//                 <strong>{selectedSnapper.city}</strong>
//                 <span>{selectedSnapper.state}</span>
//                 <em className={`si-ready ${(selectedSnapper.readiness || "unknown").toLowerCase()}`}>{selectedSnapper.readiness}</em>
//               </div>
//             </div>
//             <div className="si-profile-grid">
//               <div><small>LAST LOGIN</small><strong>{selectedSnapper.lastLogin}</strong></div>
//               <div><small>JOBS · 30D</small><strong>{selectedSnapper.jobs30}</strong></div>
//               <div><small>JOB TYPE</small><strong>{selectedSnapper.type}</strong></div>
//               <div><small>STATUS</small><strong>Active</strong></div>
//             </div>
//             <button className="si-btn si-btn-primary si-full" onClick={() => onSnapperClick?.(selectedSnapper)}>Open Snapper Profile</button>
//           </div>
//         </div>
//       )}

//       {mapOpen && (
//         <div className="si-overlay" onMouseDown={e => e.target === e.currentTarget && closeMap()}>
//           <div className="si-map-modal">
//             <div className="si-modal-head">
//               <div><span>COVERAGE INTELLIGENCE</span><h2>Snapper Coverage</h2><p>State-wise breakdown of capacity.</p></div>
//               <button onClick={closeMap}>×</button>
//             </div>
//             <div className="si-map-body">
//               <div className="si-map-states" style={{ width: "100%" }}>
//                 <div className="si-map-states-head"><strong>State-wise Coverage</strong><small>Sorted by recently working snappers</small></div>
//                 {states.map(item => (
//                   <button key={item.name} onClick={() => { setState(item.name); closeMap(); }}>
//                     <span><strong>{item.name}</strong><small>{fmt(item.registered)} registered · {fmt(item.worked30)} worked 30d</small></span>
//                     <b>{fmt(item.worked30)}</b>
//                   </button>
//                 ))}
//                 {!states.length && <div className="si-empty">No coverage points found.</div>}
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getSnapperInsightDashboard } from "../services/snapperInsightService";
import "./SnapperInsight.css";

const fmt = (n) => new Intl.NumberFormat("en-IN").format(n || 0);

function Avatar({ person }) {
  const [broken, setBroken] = useState(false);
  const name = person?.name || "Unknown";
  if (person?.avatarUrl && !broken) {
    return <img className="si-avatar" src={person.avatarUrl} alt={name} onError={() => setBroken(true)} />;
  }
  const initials = name.split(" ").map(x => x[0]).join("").slice(0, 2).toUpperCase();
  return <div className="si-avatar si-avatar-fallback">{initials}</div>;
}

function Icon({ children }) {
  return <span className="si-icon" aria-hidden="true">{children}</span>;
}

export default function SnapperInsight({
  userId: propUserId,
  onSnapperClick,
  onOpenMap,
  onExport
}) {
  const navigate = useNavigate();

  const effectiveUserId = useMemo(() => {
    if (propUserId) return propUserId;
    const storedUser = localStorage.getItem("user") || sessionStorage.getItem("user");
    if (storedUser) {
      try {
        const parsed = JSON.parse(storedUser);
        if (parsed?.id) return parsed.id;
      } catch (e) {
        // Ignored if stored as plain string ID
      }
    }
    return localStorage.getItem("userId") || sessionStorage.getItem("userId") || "";
  }, [propUserId]);

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [country, setCountry] = useState("All Countries");
  const [state, setState] = useState("All States");
  const [city, setCity] = useState("All Cities");
  const [selectedSnapper, setSelectedSnapper] = useState(null);

  useEffect(() => {
    const fetchDashboard = async () => {
      if (!effectiveUserId) {
        setLoading(false);
        setError("Missing admin user authorization ID.");
        return;
      }

      try {
        setLoading(true);
        setError(null);
        const filters = { country, city };
        const result = await getSnapperInsightDashboard(effectiveUserId, filters);
        setData(result);
      } catch (err) {
        console.error("Snapper Insight API error:", err);
        setError(err.message || "Failed to load dashboard data.");
      } finally {
        setLoading(false);
      }
    };

    fetchDashboard();
  }, [effectiveUserId, country, city]);

  const filteredCities = useMemo(() => {
    if (!data?.cities) return [];
    return data.cities.filter(row =>
      (state === "All States" || row.state === state) &&
      (city === "All Cities" || row.city === city)
    );
  }, [data?.cities, state, city]);

  const openMap = () => {
    onOpenMap?.();
    navigate("/snapper-insight/map");
  };

  const selectSnapper = (person) => {
    setSelectedSnapper(person);
    onSnapperClick?.(person);
  };

  if (loading) {
    return (
      <div className="snapper-insight si-state-container">
        <div className="si-spinner" />
        <p>Fetching Snapper Intelligence...</p>
      </div>
    );
  }

  if (error || !data) {
    return (
      <div className="snapper-insight si-state-container">
        <div className="si-error-box">
          <h2>Unable to Load Dashboard</h2>
          <p>{error || "No data available."}</p>
          <button className="si-btn si-btn-primary" onClick={() => window.location.reload()}>
            Retry
          </button>
        </div>
      </div>
    );
  }

  const { kpis, loginWindows, jobsWindows, profileHealth, filters, snappers, states } = data;

  const activePct = kpis.registered ? ((kpis.active / kpis.registered) * 100).toFixed(1) : "0.0";
  const worked30Pct = kpis.registered ? ((kpis.worked30 / kpis.registered) * 100).toFixed(1) : "0.0";

  return (
    <div className="snapper-insight">
      <div className="si-page-head">
        <div>
          <div className="si-eyebrow">OPERATIONS / PEOPLE INTELLIGENCE</div>
          <h1>Snapper Intelligence</h1>
          <p>Understand your field capacity, activity and geographic coverage before planning the next campaign.</p>
        </div>
        <div className="si-head-actions">
          <button className="si-btn si-btn-ghost" onClick={() => onExport?.()}>↓ Export</button>
          <button className="si-btn si-btn-primary" onClick={openMap}>⌖ Open Coverage Map</button>
        </div>
      </div>

      <section className="si-filterbar">
        <div className="si-filter-title">
          <span>FILTER VIEW</span>
          <small>All figures update for the selected geography</small>
        </div>
        <label>Country
          <select value={country} onChange={e => setCountry(e.target.value)}>
            {(filters?.countries || ["All Countries"]).map(x => <option key={x} value={x}>{x}</option>)}
          </select>
        </label>
        <label>State
          <select value={state} onChange={e => { setState(e.target.value); setCity("All Cities"); }}>
            {(filters?.states || ["All States"]).map(x => <option key={x} value={x}>{x}</option>)}
          </select>
        </label>
        <label>City
          <select value={city} onChange={e => setCity(e.target.value)}>
            {(filters?.cities || ["All Cities"]).map(x => <option key={x} value={x}>{x}</option>)}
          </select>
        </label>
        <button className="si-reset" onClick={() => { setCountry("All Countries"); setState("All States"); setCity("All Cities"); }}>Reset</button>
      </section>

      <section className="si-kpi-grid">
        <article className="si-kpi">
          <div className="si-kpi-icon blue"><Icon>◉</Icon></div>
          <div className="si-kpi-label">REGISTERED SNAPPERS</div>
          <div className="si-kpi-value">{fmt(kpis.registered)}</div>
          <div className="si-kpi-note">All registered snapper accounts</div>
        </article>
        <article className="si-kpi">
          <div className="si-kpi-icon green"><Icon>✓</Icon></div>
          <div className="si-kpi-label">ACTIVE ACCOUNTS</div>
          <div className="si-kpi-value">{fmt(kpis.active)}</div>
          <div className="si-kpi-note"><strong>{activePct}%</strong> of registered base</div>
        </article>
        <article className="si-kpi">
          <div className="si-kpi-icon purple"><Icon>↗</Icon></div>
          <div className="si-kpi-label">WORKED IN LAST 30 DAYS</div>
          <div className="si-kpi-value">{fmt(kpis.worked30)}</div>
          <div className="si-kpi-note"><strong>{worked30Pct}%</strong> of registered base</div>
        </article>
        <article className="si-kpi">
          <div className="si-kpi-icon amber"><Icon>◷</Icon></div>
          <div className="si-kpi-label">DORMANT 180+ DAYS</div>
          <div className="si-kpi-value">{fmt(kpis.dormant180)}</div>
          <div className="si-kpi-note">Potential reactivation pool</div>
        </article>
      </section>

      <div className="si-two-col">
        <section className="si-panel">
          <div className="si-panel-head">
            <div><h2>Login Activity</h2><p>Recency of last login across registered snappers</p></div>
          </div>
          <div className="si-bars">
            {loginWindows.map((item) => (
              <div className="si-bar-row" key={item.label}>
                <span className="si-bar-label">{item.label}</span>
                <div className="si-bar-track">
                  <div className="si-bar-fill" style={{ width: `${item.pct || 0}%` }} />
                </div>
                <strong>{fmt(item.value)}</strong>
              </div>
            ))}
          </div>
          <div className="si-insight green-note">
            <strong>Planning signal:</strong> recently logged-in snappers are a stronger near-term capacity indicator than registration count.
          </div>
        </section>

        <section className="si-panel">
          <div className="si-panel-head">
            <div><h2>Completed Jobs by Window</h2><p>Jobs with a completion date linked to a snapper</p></div>
          </div>
          <div className="si-bars si-job-bars">
            {jobsWindows.map(item => (
              <div className="si-bar-row" key={item.label}>
                <span className="si-bar-label">{item.label}</span>
                <div className="si-bar-track">
                  <div className="si-bar-fill purple-fill" style={{ width: `${item.pct || 0}%` }} />
                </div>
                <strong>{fmt(item.value)}</strong>
              </div>
            ))}
          </div>
          <div className="si-job-highlight">
            <span>{fmt(kpis.worked30)}</span>
            <div>
              <strong>Snappers worked in last 30 days</strong>
              <small>Use this as the primary operational capacity signal.</small>
            </div>
          </div>
        </section>
      </div>

      <section className="si-panel si-city-panel">
        <div className="si-panel-head">
          <div><h2>Snapper Coverage by City</h2><p>Registered base, active accounts and recently working capacity</p></div>
          <button className="si-btn si-btn-ghost si-btn-sm" onClick={openMap}>⌖ Map View</button>
        </div>
        <div className="si-table-wrap">
          <table className="si-table">
            <thead><tr><th>City</th><th>Registered</th><th>Active</th><th>Worked 30d</th><th>Capacity</th><th>Share</th><th>Signal</th></tr></thead>
            <tbody>
              {filteredCities.map(row => (
                <tr key={row.city}>
                  <td><strong>{row.city}</strong><small>{row.state}</small></td>
                  <td>{fmt(row.registered)}</td>
                  <td>{fmt(row.active)}</td>
                  <td><strong>{fmt(row.worked30)}</strong></td>
                  <td><div className="si-capacity"><div><span style={{ width: `${row.capacity || 0}%` }} /></div><em>{row.capacity || 0}%</em></div></td>
                  <td>{row.share || 0}%</td>
                  <td><span className={`si-signal ${(row.signal || "unknown").toLowerCase()}`}>{row.signal || "Unknown"}</span></td>
                </tr>
              ))}
              {!filteredCities.length && <tr><td colSpan="7" className="si-empty">No city records match the selected geography.</td></tr>}
            </tbody>
          </table>
        </div>
      </section>

      <div className="si-two-col">
        <section className="si-panel">
          <div className="si-panel-head">
            <div><h2>Recently Active Snappers</h2><p>Useful for urgent and location-sensitive jobs</p></div>
          </div>
          <div className="si-snapper-grid">
            {snappers.slice(0, 6).map(person => (
              <button className="si-snapper-card" key={person.id} onClick={() => selectSnapper(person)}>
                <Avatar person={person} />
                <div className="si-snapper-info">
                  <strong>{person.name}</strong>
                  <span>{person.city} · {person.type}</span>
                  <small>Completed <b>{person.jobs30}</b> jobs · Last login <b>{person.lastLogin}</b></small>
                </div>
                <span className={`si-ready ${(person.readiness || "unknown").toLowerCase()}`}>{person.readiness}</span>
              </button>
            ))}
            {!snappers.length && <div className="si-empty">No active snappers found.</div>}
          </div>
        </section>

        <section className="si-panel">
          <div className="si-panel-head">
            <div><h2>State-wise Coverage</h2><p>Top states by snappers who worked in the last 30 days</p></div>
          </div>
          <div className="si-state-list">
            {states.map((item, i) => (
              <div className="si-state-row" key={item.name}>
                <div>
                  <strong>{item.name}</strong>
                  <small>{fmt(item.registered)} registered</small>
                  <div className="si-state-track"><span style={{ width: `${Math.max(8, 100 - i * 11)}%` }} /></div>
                </div>
                <b>{fmt(item.worked30)}</b>
              </div>
            ))}
            {!states.length && <div className="si-empty">No state breakdown available.</div>}
          </div>
        </section>
      </div>

      <section className="si-panel si-readiness">
        <div className="si-panel-head">
          <div><h2>Snapper Readiness</h2><p>Onboarding and account signals useful before assigning new work</p></div>
        </div>
        <div className="si-readiness-grid">
          <div>
            <span>Active account</span>
            <strong>{fmt(kpis.active)} <small>{activePct}%</small></strong>
            <div className="si-progress"><i style={{ width: `${activePct}%` }} /></div>
          </div>
          <div>
            <span>Photo-job onboarding complete</span>
            <strong>{fmt(profileHealth.photoOnboarding)} <small>{profileHealth.photoOnboardingPct}%</small></strong>
            <div className="si-progress"><i style={{ width: `${profileHealth.photoOnboardingPct}%` }} /></div>
          </div>
          <div>
            <span>Video-job onboarding complete</span>
            <strong>{fmt(profileHealth.videoOnboarding)} <small>{profileHealth.videoOnboardingPct}%</small></strong>
            <div className="si-progress"><i style={{ width: `${profileHealth.videoOnboardingPct}%` }} /></div>
          </div>
          <div>
            <span>Blocked accounts</span>
            <strong>{fmt(profileHealth.blocked)} <small>{profileHealth.blockedPct}%</small></strong>
            <div className="si-progress warning"><i style={{ width: `${profileHealth.blockedPct}%` }} /></div>
          </div>
        </div>
      </section>

      {selectedSnapper && (
        <div className="si-overlay" onMouseDown={e => e.target === e.currentTarget && setSelectedSnapper(null)}>
          <div className="si-drawer">
            <div className="si-drawer-head">
              <div><span>SNAPPER PROFILE</span><h2>{selectedSnapper.name}</h2></div>
              <button onClick={() => setSelectedSnapper(null)}>×</button>
            </div>
            <div className="si-profile-top">
              <Avatar person={selectedSnapper} />
              <div>
                <strong>{selectedSnapper.city}</strong>
                <span>{selectedSnapper.state}</span>
                <em className={`si-ready ${(selectedSnapper.readiness || "unknown").toLowerCase()}`}>{selectedSnapper.readiness}</em>
              </div>
            </div>
            <div className="si-profile-grid">
              <div><small>LAST LOGIN</small><strong>{selectedSnapper.lastLogin}</strong></div>
              <div><small>JOBS · 30D</small><strong>{selectedSnapper.jobs30}</strong></div>
              <div><small>JOB TYPE</small><strong>{selectedSnapper.type}</strong></div>
              <div><small>STATUS</small><strong>Active</strong></div>
            </div>
            <button className="si-btn si-btn-primary si-full" onClick={() => onSnapperClick?.(selectedSnapper)}>Open Snapper Profile</button>
          </div>
        </div>
      )}
    </div>
  );
}
